
// Filter bar
const handleFilter = e => {
  e.preventDefault();
  const filter = e.target.id;
  document.querySelectorAll('.integrations-filter-link').forEach(navLink => {
    if (navLink.id == filter) {
      navLink.classList.add('active');
    } else {
      navLink.classList.remove('active');
    }
  });

  const integrations = document.querySelectorAll('.integration-item');
  integrations.forEach(integration => 
    integration.style.display =
      (integration.classList.contains('integration-category-'+filter) || filter == 'show_all') ?
        'block' :
        'none'
  );
};

document.querySelectorAll('.integrations-filter-link').forEach(navLink => {
  navLink.addEventListener('click', handleFilter)
});

// simluate filter click for detail page breadcrumbs
const url = new URL(window.location.href);
const breadcrumbCategory = document.querySelector('#' + url.searchParams.get("category"))
if (breadcrumbCategory != null) {
  breadcrumbCategory.dispatchEvent(new Event('click'));
}
